import React, { useEffect, useRef, useState } from 'react';

const TickerTape = () => {
    const containerRef = useRef(null);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        // Détecter si on est sur mobile
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        // Ne pas charger le widget sur mobile
        if (isMobile) return;

        // Nettoyer le contenu existant
        const containerRef_ = containerRef.current;
        if (containerRef_) {
            containerRef_.innerHTML = '';
        }

        // Créer le script TradingView
        const script = document.createElement('script');
        script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
        script.type = 'text/javascript';
        script.async = true;
        script.innerHTML = JSON.stringify({
            "symbols": [
                {
                    "proName": "FOREXCOM:SPXUSD",
                    "title": "S&P 500"
                },
                {
                    "proName": "FOREXCOM:NSXUSD",
                    "title": "US 100"
                },
                {
                    "proName": "FX_IDC:EURUSD",
                    "title": "EUR to USD"
                },
                {
                    "proName": "BITSTAMP:BTCUSD",
                    "title": "Bitcoin"
                },
                {
                    "proName": "NASDAQ:AAPL",
                    "title": "Apple"
                },
                {
                    "proName": "NASDAQ:GOOGL",
                    "title": "Alphabet Inc"
                }
            ],
            "showSymbolLogo": true,
            "colorTheme": "dark",
            "isTransparent": true,
            "displayMode": "adaptive",
            "locale": "en"
        });

        // Créer le conteneur du widget
        const widgetContainer = document.createElement('div');
        widgetContainer.className = 'tradingview-widget-container';

        const widgetDiv = document.createElement('div');
        widgetDiv.className = 'tradingview-widget-container__widget';

        widgetContainer.appendChild(widgetDiv);
        widgetContainer.appendChild(script);

        // Ajouter au DOM
        if (containerRef_) {
            containerRef_.appendChild(widgetContainer);
        }

        // Nettoyage au démontage du composant
        return () => {
            if (containerRef_) {
                containerRef_.innerHTML = '';
            }
        };
    }, [isMobile]);

    // Ne rien afficher sur mobile
    if (isMobile) {
        return null;
    }

    return (
        <div className="w-full bg-dark-secondary border-b border-dark-border">
            <div
                ref={containerRef}
                className="w-full h-12 overflow-hidden"
                style={{ minHeight: '48px' }}
            />
        </div>
    );
};

export default TickerTape;